import { addApplicationForm } from "../../api/Applications";
import { convertBufferArrayToBase64 } from "../../utils/ImageToBase64";

class ViewSDKClient {
  constructor() {
    this.readyPromise = new Promise((resolve) => {
      if (window.AdobeDC) {
        resolve();
      } else {
        document.addEventListener("adobe_dc_view_sdk.ready", () => {
          resolve();
        });
      }
    });
    this.adobeDCView = undefined;
    this.pdfContent = null; // Store PDF content here
  }

  ready() {
    return this.readyPromise;
  }

  previewFile(divId, viewerConfig, url) {
    const config = {
      clientId: localStorage.getItem("REACT_APP_ADOBE_READER_CLIENT_ID")
    };
    if (divId) {
      config.divId = divId;
    }
    this.adobeDCView = new window.AdobeDC.View(config);
    this.adobeDCView.previewFile(
      {
        content: {
          location: {
            url: url
          }
        },
        metaData: {
          fileName: "Menu.pdf",
          id: "6d07d124-ac85-43b3-a867-36930f502ac6"
        }
      },
      viewerConfig
    );
  }

  registerSaveApiHandler() {
    const saveOptions = {
      // autoSaveFrequency: 1, // unit is in seconds
      // enableFocusPolling: true,
      filePollFrequency: 0,
      showSaveButton: true,
      keepPolling :false
    };

    this.adobeDCView.registerCallback(
      window.AdobeDC.View.Enum.CallbackType.SAVE_API,
      (metaData, content, options) => this.handleSave(metaData, content, options),
      saveOptions
    );
  }

  // Save handler to capture the content buffer
  async handleSave(metaData, content, options) {
    // Store the PDF content for custom "Save" button access
    this.pdfContent = content;

    // Convert to base64 string
    const base64String = convertBufferArrayToBase64(content);

    this.savePdfHandler();

    // Return the save response
    return new Promise((resolve, reject) => {
        if (base64String) {
            // On success
            resolve({
                code: window.AdobeDC.View.Enum.ApiResponseCode.SUCCESS,
                data: {
                    metaData: {
                        ...metaData,
                        updatedAt: new Date().getTime() // Update metadata with timestamp
                    }
                }
            });
        } else {
            // On failure
            reject({
                code: window.AdobeDC.View.Enum.ApiResponseCode.FAIL,
                data: {
                    error: "Failed to save PDF content"
                }
            });
        }
    });
}


  // Method to get PDF content when needed
  getPdfContent() {
    return this.pdfContent;
  }

  // Send to server
  async sendToServer(payload, dispatch, token, applicationId) {
    let res = await addApplicationForm({ values: payload, dispatch, token, applicationId });
    return res;
  }
}

export default ViewSDKClient;
